const methy_DM_level = {
  "Leaf": {
    "CA12DAP_1": "/api/static/methy/methy_DM_level/CA12DAP_1.mCX_methlevel_distribution.png",
    "CA12DAP_2": "/api/static/methy/methy_DM_level/CA12DAP_2.mCX_methlevel_distribution.png",
    "CA12DAP_3": "/api/static/methy/methy_DM_level/CA12DAP_3.mCX_methlevel_distribution.png",
    "CA15DAP_1": "/api/static/methy/methy_DM_level/CA15DAP_1.mCX_methlevel_distribution.png",
    "CA15DAP_2": "/api/static/methy/methy_DM_level/CA15DAP_2.mCX_methlevel_distribution.png",
    "CA15DAP_3": "/api/static/methy/methy_DM_level/CA15DAP_3.mCX_methlevel_distribution.png",
    "CA9DAP_1": "/api/static/methy/methy_DM_level/CA9DAP_1.mCX_methlevel_distribution.png",
    "CA9DAP_2": "/api/static/methy/methy_DM_level/CA9DAP_2.mCX_methlevel_distribution.png",
    "CA9DAP_3": "/api/static/methy/methy_DM_level/CA9DAP_3.mCX_methlevel_distribution.png",
    "ZY12DAP_1": "/api/static/methy/methy_DM_level/ZY12DAP_1.mCX_methlevel_distribution.png",
    "ZY12DAP_2": "/api/static/methy/methy_DM_level/ZY12DAP_2.mCX_methlevel_distribution.png",
    "ZY12DAP_3": "/api/static/methy/methy_DM_level/ZY12DAP_3.mCX_methlevel_distribution.png",
    "ZY15DAP_1": "/api/static/methy/methy_DM_level/ZY15DAP_1.mCX_methlevel_distribution.png",
    "ZY15DAP_2": "/api/static/methy/methy_DM_level/ZY15DAP_2.mCX_methlevel_distribution.png",
    "ZY15DAP_3": "/api/static/methy/methy_DM_level/ZY15DAP_3.mCX_methlevel_distribution.png",
    "ZY9DAP_1": "/api/static/methy/methy_DM_level/ZY9DAP_1.mCX_methlevel_distribution.png",
    "ZY9DAP_2": "/api/static/methy/methy_DM_level/ZY9DAP_2.mCX_methlevel_distribution.png",
    "ZY9DAP_3": "/api/static/methy/methy_DM_level/ZY9DAP_3.mCX_methlevel_distribution.png"
  },
 
}
let ChangeDmOptions=[]
Object.keys(methy_DM_level).map(key=>{
  console.log(key)
  ChangeDmOptions.push({
    label:key,
    value:key
  })
})
export {methy_DM_level,ChangeDmOptions}